import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
// import { BrowserRouter } from 'react-router-dom';
import registerServiceWorker from './registerServiceWorker';
ReactDOM.render(
        // <BrowserRouter>
            <App />
        // </BrowserRouter>
    , document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js